var styles = {"wrapper":"styles_wrapper__3U-dG","menu":"styles_menu__3_HxA","content":"styles_content__3dB5h","title":"styles_title__2vYWj","fieldsetTitle":"styles_fieldsetTitle__rVFmJ","subtitle":"styles_subtitle__1pYKp","picture3x2":"styles_picture3x2__OLyNM","spinAround":"styles_spinAround__2kHkp"};

export { styles as default };
//# sourceMappingURL=styles.scss.js.map
